// Copyright (c) 2017 Deere & Company

import './labor-rate-link-panel.scss';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router';
import React from 'react';
import {secure} from '../../../shared/components/security-wrapper/secure';

const LaborRateLinkPanel = () =>
    <div className='labor-rate-link'>
        <Link to='/claims/labor-rates'>
            <FormattedMessage id='UPDATE_LABOR_RATES'/>
        </Link>
    </div>;

LaborRateLinkPanel.displayName = 'LaborRateLinkPanel';

export default secure('CLAIM', 'CLM_LABOR_RATE')(LaborRateLinkPanel);



// WEBPACK FOOTER //
// ./src/claim/shared/components/labor-rate-link-panel.js